import {
    getGlobalVal, pageVerify, getVersion, getGlobalCountryList, changeAxiosUrl,
} from '@/api/sys/config';
import { getPackagePreferentialInfo } from '@/api/sys/project/order';
import config from '@/config/index';
import { Params } from '@/libs/types';
import { localRead, localSave } from '@/libs/util';
import { getField, updateField } from '@/libs/vuexHelper';

const {
    career,
    industry,
    scope,
    fbccLogin,
    fbccArea,
    fbccType,
    fbccAccount,
    platformConfig,
} = config;

interface Item {
    name: string | number;
    value: string;
}

interface IgnoreRegionOrCity {
    key: string[];
}

interface State {
    careerList: Item[];
    industryList: Item[];
    scaleList: Item[];
    fbccLoginList: Item[];
    fbccAreaList: Item[];
    fbccTypeList: Item[];
    fbccAccountList: Item[];
    createBmSupportCountryList: string[];
    platformConfigList: string[];
    ignoreRegionOrCity: IgnoreRegionOrCity;
    packageInfo: any;
    extraUserInfo: any;
    uniqueId: string;
    packagePreferentialInfo: any;
}

export default {
    namespaced: true,
    state: {
        careerList: [],
        industryList: [],
        scaleList: [],
        fbccLoginList: [],
        fbccAreaList: [],
        fbccTypeList: [],
        fbccAccountList: [],
        createBmSupportCountryList: [],
        platformConfigList: [],
        ignoreRegionOrCity: {},
        packageInfo: [
            {
                id: 'package_10',
                account_num: '10',
                user_unit_price: '1',
                gift_user_num: '1',
                all_user_num: '2',
                fee: '10',
            },
            {
                id: 'package_25',
                account_num: '50',
                user_unit_price: '0.5',
                gift_user_num: '0',
                all_user_num: '1',
                fee: '25',
            },
            {
                id: 'package_50',
                account_num: '100',
                user_unit_price: '0.5',
                gift_user_num: '1',
                all_user_num: '2',
                fee: '50',
            },
            {
                id: 'package_100',
                account_num: '200',
                user_unit_price: '0.5',
                gift_user_num: '4',
                all_user_num: '5',
                fee: '100',
            },
            {
                id: 'package_200',
                account_num: '500',
                user_unit_price: '0.4',
                gift_user_num: '8',
                all_user_num: '9',
                fee: '200',
            },
            {
                id: 'package_300',
                account_num: '1000',
                user_unit_price: '0.3',
                gift_user_num: '12',
                all_user_num: '13',
                fee: '300',
            },
            {
                id: 'package_400',
                account_num: '2000',
                user_unit_price: '0.2',
                gift_user_num: '16',
                all_user_num: '17',
                fee: '400',
            },
            {
                id: 'package_500',
                account_num: '3000',
                user_unit_price: '0.17',
                gift_user_num: '20',
                all_user_num: '21',
                fee: '500',
            },
            {
                id: 'package_600',
                account_num: '5000',
                user_unit_price: '0.12',
                gift_user_num: '24',
                all_user_num: '25',
                fee: '600',
            },
            {
                id: 'package_700',
                account_num: '6000',
                user_unit_price: '0.11',
                gift_user_num: '28',
                all_user_num: '29',
                fee: '700',
            },
            {
                id: 'package_800',
                account_num: '7000',
                user_unit_price: '0.115',
                gift_user_num: '32',
                all_user_num: '33',
                fee: '800',
            },
            {
                id: 'package_900',
                account_num: '8000',
                user_unit_price: '0.113',
                gift_user_num: '36',
                all_user_num: '37',
                fee: '900',
            },
            {
                id: 'package_1000',
                account_num: '10000',
                user_unit_price: '0.1',
                gift_user_num: '40',
                all_user_num: '41',
                fee: '1000',
            },
        ],
        extraUserInfo: [
            {
                min_user_num: '1',
                max_user_num: '20',
                user_unit_price: '20',
                user_original_price: '20',
                user_day_price: '0.67',
            },
            {
                min_user_num: '21',
                max_user_num: '50',
                user_unit_price: '15',
                user_original_price: '20',
                user_day_price: '0.5',
            },
            {
                min_user_num: '51',
                max_user_num: '100',
                user_unit_price: '10',
                user_original_price: '20',
                user_day_price: '0.34',
            },
            {
                min_user_num: '101',
                max_user_num: '200',
                user_unit_price: '8',
                user_original_price: '20',
                user_day_price: '0.27',
            },
        ],
        uniqueId: '',
        packagePreferentialInfo: {},
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
        setPackagePreferentialInfo(state: State, info: any) {
            state.packagePreferentialInfo = info;
        },
        setPackageInfo(state: State, packageInfo: any) {
            const that = state;
            that.packageInfo = packageInfo;
        },
        setExtraUserInfo(state: State, extraUserInfo: any) {
            const that = state;
            that.extraUserInfo = extraUserInfo;
        },
        setCareer(state: State, list: Item[]) {
            const that: State = state;
            that.careerList = list;
        },
        setIndustry(state: State, list: Item[]) {
            const that: State = state;
            that.industryList = list;
        },
        setScale(state: State, list: Item[]) {
            const that: State = state;
            that.scaleList = list;
        },
        setFbccLoginList(state: State, list: Item[]) {
            const that: State = state;
            that.fbccLoginList = list;
        },
        setFbccAreaList(state: State, list: Item[]) {
            const that: State = state;
            that.fbccAreaList = list;
        },
        setFbccTypeList(state: State, list: Item[]) {
            const that: State = state;
            that.fbccTypeList = list;
        },
        setFbccAccountList(state: State, list: Item[]) {
            const that: State = state;
            that.fbccAccountList = list;
        },
        setCreateBmSupportCountryList(state: State, list: string[]) {
            const that: State = state;
            that.createBmSupportCountryList = list;
        },
        setPlatformConfigList(state: State, list: any) {
            const that: State = state;
            that.platformConfigList = list;
        },
        setIgnoreRegionOrCity(state: State, list: any) {
            const that: State = state;
            that.ignoreRegionOrCity = list;
        },
        setUniqueId(state: State, id: string) {
            const that: State = state;
            that.uniqueId = id;
        },
    },
    actions: {
        fetchPackagePreferentialInfo({ commit }: any) {
            return getPackagePreferentialInfo().then((res) => {
                commit('setPackagePreferentialInfo', res.data.data);
            }).catch(console.log);
        },
        getGlobalVal({ commit }: any, key: string) {
            return new Promise((resolve, reject) => {
                getGlobalVal(key).then((res: any) => {
                    const { data } = res;
                    const { list } = data.data;
                    const keyArray = key.split(',');
                    keyArray.map((item: string) => {
                        if (list[item]) {
                            if (item === career.cn || item === career.en) {
                                commit('setCareer', list[item]);
                            }
                            if (item === industry.cn || item === industry.en) {
                                commit('setIndustry', list[item]);
                            }
                            if (item === scope.cn || item === scope.en) {
                                commit('setScale', list[item]);
                            }
                            if (item === fbccLogin.cn || item === fbccLogin.en) {
                                commit('setFbccLoginList', list[item]);
                            }
                            if (item === fbccArea.cn || item === fbccArea.en) {
                                commit('setFbccAreaList', list[item]);
                            }
                            if (item === fbccType.cn || item === fbccType.en) {
                                commit('setFbccTypeList', list[item]);
                            }
                            if (item === fbccAccount.cn || item === fbccAccount.en) {
                                commit('setFbccAccountList', list[item]);
                            }
                            if (item === platformConfig) {
                                commit('setPlatformConfigList', list[item]);
                            }
                        }
                        return item;
                    });
                    if (key === 'IGNORE_REGION_OR_CITY' && list[key]) {
                        commit('setIgnoreRegionOrCity', list[key]);
                    }
                    if (key === 'SIXTH_PACKAGE_INFO' && list[key]) {
                        if (list[key].package_info) {
                            const packageInfo = list[key].package_info;
                            const packageArr = [];
                            for (const pack in packageInfo) {
                                if (Object.prototype.hasOwnProperty.call(packageInfo, pack)) {
                                    const item = packageInfo[pack];
                                    item.id = pack;
                                    packageArr.push(item);
                                }
                            }
                            commit('setPackageInfo', packageArr);
                        }
                        if (list[key].extra_user_info) {
                            commit('setExtraUserInfo', list[key].extra_user_info);
                        }
                    }
                    resolve(res.data);
                }).catch((err: any) => {
                    reject(err);
                });
            });
        },
        pageVerify({ commit }: any, { token, type }: Params) {
            return new Promise((resolve, reject) => {
                pageVerify({
                    token,
                    type,
                })
                    .then((res: any) => {
                        resolve(res);
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        },
        getVersion({ commit }: any) {
            return getVersion();
        },
        changeAxiosUrl({ commit }: any, baseUrl: string) {
            changeAxiosUrl(baseUrl);
        },
        getGlobalCountryList({ commit }: any) {
            getGlobalCountryList().then((res: any) => {
                commit('setCreateBmSupportCountryList', res.data.data.list);
            }).catch(() => {
                //
            });
        },
        toGetInfo({ commit }: any, sysUserId: string) {
            const time = new Date().getTime();
            const localTime = localRead('LOCAL_TIME');
            if (localTime && (time - +localTime) < 2 * 60 * 60 * 1000) {
                return;
            }
            localSave('LOCAL_TIME', time.toString());
        },
        getUniqueId({ commit }: any) {
        },
    },
};
